<template>
  <div :class="['mb-6', { 'has-errors': errorText }]">
    <slot name="label">
      <label
        v-if="label"
        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        :for="id">
        {{ label }}
        <span v-if="required" class="inline-block align-top text-red-400">
          *
        </span>
        <i v-if="tooltipText" v-tooltip="tooltipText" class="fa fa-circle-info ml-1 text-blue-300" />
        <div class="inline-flex align-middle pl-1">
          <UiFormCheckbox
            v-if="typeof fieldDisabled === 'boolean'"
            :model-value="!fieldDisabled"
            class="text-base"
            @update:model-value="emits('fieldDisabled', !$event)" />
        </div>
      </label>
    </slot>

    <slot />

    <!-- eslint-disable-next-line vue/no-v-html -->
    <small v-if="hint" class="py-1 block text-gray-900 dark:text-white" v-html="hintParsed" />
    <small v-if="errorText" class="errors-text">
      {{ errorText }}
    </small>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import vTooltip from '@/vue/directives/tooltip'
import { UiFormCheckbox } from '@ui/form/checkbox'

const props = defineProps({
  label: { type: String },
  id: { type: String, required: true },
  hint: { type: String },
  required: { type: Boolean, deafult: false },
  tooltipText: { type: String, default: '' },
  fieldDisabled: { required: false },
  errors: { type: [Array, Object], default: () => []},
  kind: { type: String, default: 'text' }
})

const emits = defineEmits(['fieldDisabled'])

// const hintParsed = computed(() => {
//   const linkPattern = /(?<!href=["'])\bhttps?:\/\/[^\s<>"]+/g
//   return props.hint.replace(linkPattern, '<a href="$&" class="text-blue-600" target="_blank">$&</a>')
// })

const hintParsed = computed(() => {
  const linkPattern = /(?<!href=["'])(\bhttps?:\/\/[^\s<>"]+?)([.,!?;:]+)?(?=\s|$)/g;

  return props.hint.replace(linkPattern, (match, url, punctuation) => {
    const replaceText = `<a href="${url}" class="text-blue-600" target="_blank">${url}</a>${punctuation || ''}`
    return replaceText
  })
})

const errorText = computed(() => {
  if (props.kind === 'week_schedule') return ''
  if (!Array.isArray(props.errors) || !props.errors.length) return ''

  return props.errors.join(', ')
})
</script>
